import { render, staticRenderFns } from "./workflow-output-settings.vue?vue&type=template&id=544a8536&scoped=true"
import script from "./workflow-output-settings.vue?vue&type=script&lang=js"
export * from "./workflow-output-settings.vue?vue&type=script&lang=js"
import style0 from "./workflow-output-settings.vue?vue&type=style&index=0&id=544a8536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544a8536",
  null
  
)

export default component.exports